const env = process.env.REACT_APP_ENV;
let redirectUri = 'http://localhost:3000';
let oAuth2Url = 'https://test-login.dakika.com.tr';
let galleryRedirect = 'https://test-gallery.dakika.com.tr';
let dakikaUrl = 'https://test.dakika.com.tr';
console.log("env",env)

if (env === 'local') {
  redirectUri = 'http://localhost:3000';
  oAuth2Url = 'http://dev.sso-service.dtst.k8s';
  galleryRedirect = 'http://dev-gallery.dakika.com.tr';
} else if (env === 'development') {
  redirectUri = 'https://dev-glasshouse-harcirah.dakika.com.tr';
  oAuth2Url = 'http://dev.sso-service.dtst.k8s';
  galleryRedirect = 'http://dev-gallery.dakika.com.tr';
  dakikaUrl = 'https://dev.dakika.com.tr';
} else if (env === 'test') {
  redirectUri = 'https://test-harcirah.dakika.com.tr';
  oAuth2Url = 'https://test-login.dakika.com.tr';
  galleryRedirect = 'https://test-gallery.dakika.com.tr';
  dakikaUrl = 'https://test.dakika.com.tr';
} else if (env === 'production') {
  redirectUri = 'https://harcirah.dakika.com.tr';
  oAuth2Url = 'https://login.dakika.com.tr';
  galleryRedirect = 'https://gallery.dakika.com.tr';
  dakikaUrl = 'https://app.dakika.com.tr';
}

export default{
  url: oAuth2Url,
  authorizationPath: '/oauth/authorize',
  checkUserPath: '/oauth/user',
  clientId: 'dakika3g-fe',
  redirectUri,
  galleryRedirect,
  dakikaUrl,
  responseType: 'code',
  scope: 'uid',
};



// WEBPACK FOOTER //
// ./src/constants/OAuth2.js